import androidImg from '../assets/img/android-logo.svg';
import appleImg from '../assets/img/apple-logo.svg';
import crossImg from '../assets/img/cross-platform-logo.svg';
import gearImg from '../assets/img/gear-logo.svg';

const platforms = {
    android: {
        id: 1,
        img: androidImg,
        name: "Android",
    },
    apple: {
        id: 2,
        img: appleImg,
        name: "iOS",
    },
    cross: {
        id: 3,
        img: crossImg,
        name: "Cross-Platform",
    },
    gear: {
        id: 4,
        img: gearImg,
        name: "Refining & Optimization",
    },
}

export {
    platforms,
}